import {type AppState, Auth0Provider} from '@auth0/auth0-react';
import {useNavigate} from 'react-router-dom';
import {getAuth0Audience, getAuth0ClientId, getAuth0Domain} from './utils/runtimeVars';

interface Auth0Config {
  domain: string;
  clientId: string;
  audience: string;
  useRefreshTokens: boolean;
}

const getAuth0Config = (): Auth0Config => ({
  domain: getAuth0Domain(),
  clientId: getAuth0ClientId(),
  audience: getAuth0Audience(),
  useRefreshTokens: import.meta.env.NODE_ENV !== 'development',
});

export const withOAuth0 = (Component: React.ComponentType) => {
  return function WrappedComponent() {
    const navigate = useNavigate();
    const config = getAuth0Config();

    const handleRedirectCallback = (appState?: AppState) => {
      const targetUrl = appState?.targetUrl ?? window.location.pathname;
      navigate(targetUrl, {replace: true});
    };

    return (
      <Auth0Provider
        domain={config.domain}
        clientId={config.clientId}
        onRedirectCallback={handleRedirectCallback}
        cacheLocation="localstorage"
        useRefreshTokens={config.useRefreshTokens}
        useRefreshTokensFallback={config.useRefreshTokens}
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: config.audience,
        }}
      >
        <Component />
      </Auth0Provider>
    );
  };
};
